import React, { useEffect, useState } from 'react';

import clsx from 'clsx';

import {
    GridColumnMenuSort,
    GridColumnMenuFilter,
    GridColumnMenuItemGroup,
    GridColumnMenuItem,
    GridColumnMenuItemContent
} from '@progress/kendo-react-grid';

import * as classes from './ColumnFilterMenu.module.css';

const actionsColumn = {
    title:       '',
    field:       '',
    locked:      true,
    sortable:    false,
    filterable:  false,
    width:       75,
    show:        true,
    actionCell:  true,
    reorderable: false
};

const ColumnFilterMenu = ({
    addCalculatedColumn,
    allowFormatting,
    allowFormula,
    allowFiltering,
    columns,
    createConditionalFormat,
    editCalculatedColumn,
    formatObj,
    isFormula,
    removeCalculatedColumn,
    setFormatObj,
    setFormatList,
    updateColumns,
    updateUserView,
    ...props
}) => {
    const [columnsExpanded, setColumnsExpanded] = useState(false);
    const [filterExpanded, setFilterExpanded] = useState(false);
    const [activeColumns, setActiveColumns] = useState([]);

    const oneVisibleColumn = activeColumns.filter(c => c.show).length === 1;

    useEffect(() => {
        if (columns) {
            let filteredColumns = columns.filter(item => item.field && !item.hidden);
            setActiveColumns(filteredColumns);
        }
    }, [columns]);

    const onFilterExpandChange = value => {
        setFilterExpanded(value);
        setColumnsExpanded(value ? false : columnsExpanded);
    };

    const onMenuItemClick = () => {
        const value = !columnsExpanded;
        setColumnsExpanded(value);
        setFilterExpanded(value ? false : filterExpanded);
    };

    const handleCheckBox = id => {
        const newColumns = activeColumns.map((column, idx) => {
            return idx === id ? {
                ...column,
                orderIndex: 1,
                show:       !column.show
            } : column;
        });
        setActiveColumns(newColumns);    
    };

    const handleSubmit = event => {
        if (event) {
            event.preventDefault();
        }

        let totalColumns = [...activeColumns, actionsColumn];

        updateColumns(totalColumns);

        if (props.onCloseMenu) {
            props.onCloseMenu();
        }
    };

    const handleReset = event => {
        event.preventDefault();
        const newColumns = props.columns.map(col => {
            return {
                ...col,
                show: true
            };
        });
        updateColumns(newColumns);
        props.onColumnsSubmit(newColumns);
        if (props.onCloseMenu) {
            props.onCloseMenu();
        }
    };

    const clearColumnFormatting = info => {
        props.onCloseMenu();
        let format = formatObj;
        if (format[info.column.field]) {
            delete format[info.column.field];
        }
        setFormatObj(format);
        updateUserView(format);
        setFormatList([]);
    };

    const clearTableFormat = () => {
        props.onCloseMenu();
        setFormatObj({});
        updateUserView({});
        setFormatList([]);
    };

    return (
        <div>
            <GridColumnMenuSort {...props} />
            {
                allowFiltering ?
                    <GridColumnMenuFilter {...props} onExpandChange={onFilterExpandChange} expanded={filterExpanded} />
                    :
                    null
            }
            {
                allowFormatting ?
                    <GridColumnMenuItemGroup>
                        <GridColumnMenuItem
                            onClick={() => createConditionalFormat(props)}
                            title="Conditional Formatting"
                            iconClass={'k-i-plus'}
                        />
                        <GridColumnMenuItem
                            onClick={() => clearColumnFormatting(props)}
                            title="Clear Column Formatting"
                            iconClass={'k-i-reset-sm'}
                        />
                        <GridColumnMenuItem
                            onClick={() => clearTableFormat()}
                            title="Clear Table Formatting"
                            iconClass={'k-i-x'}
                        />
                    </GridColumnMenuItemGroup>
                    :
                    null
            }
            {
                allowFormula ?
                    <GridColumnMenuItemGroup>
                        <GridColumnMenuItem
                            onClick={() => addCalculatedColumn(props)}
                            title="Add Formula Column"
                            iconClass={'k-i-formula-fx'}
                        />
                        {
                            isFormula ?
                                <React.Fragment>
                                    <GridColumnMenuItem
                                        onClick={() => editCalculatedColumn(props)}
                                        title="Edit Formula Column"
                                        iconClass={'k-i-track-changes'}
                                    />
                                    <GridColumnMenuItem
                                        onClick={() => removeCalculatedColumn(props)}
                                        title="Remove Formula Column"
                                        iconClass={'k-i-track-changes-reject'}
                                    />
                                </React.Fragment>
                                :
                                null
                        }
                    </GridColumnMenuItemGroup>
                    :
                    null
            }
            <GridColumnMenuItemGroup>
                <GridColumnMenuItem title={'Columns'} iconClass={'k-i-columns'} onClick={onMenuItemClick} />
                <GridColumnMenuItemContent show={columnsExpanded}>
                    <div className={'k-column-list-wrapper'}>
                        <form onSubmit={() => handleSubmit()} onReset={() => handleReset}>
                            <div className={'k-column-list'}>
                                {activeColumns.map((column, idx) => <div key={idx} className={'k-column-list-item'}>
                                    <span>
                                        <input
                                            id={`column-visiblity-show-${idx}`} 
                                            className="k-checkbox k-checkbox-md k-rounded-md" 
                                            type="checkbox"
                                            readOnly={true} 
                                            checked={column.show}
                                            disabled={(column.show && oneVisibleColumn) || column.primaryKey} 
                                            onClick={() => {
                                                handleCheckBox(idx);
                                            }}
                                        />
                                        <label
                                            htmlFor={`column-visiblity-show-${idx}`} className={clsx('k-checkbox-label', classes.Font)} style={{
                                                paddingLeft: '1rem',
                                                userSelect:  'none'
                                            }}
                                        >
                                            {column.title || 'Actions'}
                                        </label>
                                    </span>
                                </div>)}
                            </div>
                            <div className={'k-actions k-hstack k-justify-content-stretch'}>
                                <button type={'reset'} className={classes.Button}>Reset</button>
                                <button className={classes.Button}>Save</button>
                            </div>
                        </form>
                    </div>
                </GridColumnMenuItemContent>
            </GridColumnMenuItemGroup>
        </div>
    );
};

export default ColumnFilterMenu;
